module.exports = __webpack_public_path__ + "img/partlycloudy.b19a6f73.png";